export default __webpack_public_path__ + "static/media/app_store.04513ab0.png";